var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "booking-block",
    {
      ref: "bookingblock",
      staticClass: "booking-block--order-details",
      attrs: {
        editMode: _vm.editMode,
        valid: !_vm.validForm,
        title: _vm.translations.your_details_header,
        subTitle: _vm.subHeader
      },
      on: {
        save: _vm.saveAndClose,
        edit: function($event) {
          _vm.$emit("edit")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "edit" },
        [
          _c(
            "div",
            { staticClass: "input-fields" },
            [
              _c(
                "div",
                { staticClass: "input-fields__content" },
                [
                  _c("input-field", {
                    staticClass: "booking-field booking-field--firstname",
                    attrs: {
                      name: _vm.translations.input_firstname,
                      value: _vm.value.firstName,
                      "icon-type":
                        _vm.validForm && _vm.validForm.firstName
                          ? ""
                          : this.checkmarkIcon
                    },
                    on: {
                      input: function(firstName) {
                        this$1.updateCustomer({
                          firstName: firstName
                        })
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input-field", {
                    staticClass: "booking-field booking-field--lastname",
                    attrs: {
                      name: _vm.translations.input_lastname,
                      value: _vm.value.lastName,
                      "icon-type":
                        _vm.validForm && _vm.validForm.lastName
                          ? ""
                          : this.checkmarkIcon
                    },
                    on: {
                      input: function(lastName) {
                        this$1.updateCustomer({
                          lastName: lastName
                        })
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.errors.firstName || _vm.errors.lastName
                ? _c("msg-block", { attrs: { type: "error" } }, [
                    _vm.errors.firstName
                      ? _c("p", [
                          _c("b", {
                            domProps: {
                              textContent: _vm._s(_vm.errors.firstName[0])
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errors.lastName
                      ? _c("p", [
                          _c("b", {
                            domProps: {
                              textContent: _vm._s(_vm.errors.lastName[0])
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-fields" },
            [
              _c(
                "div",
                { staticClass: "input-fields__content" },
                [
                  _c("autosuggestion", {
                    staticClass: "booking-field booking-field--address",
                    attrs: {
                      text: _vm.translations.input_address,
                      value: _vm.value.address,
                      setOnSelect: false,
                      loading: _vm.addressSugestionLoading,
                      dataList: _vm.addressSusgestionList,
                      listFilter: false,
                      "filter-on-object": "description",
                      "icon-type":
                        _vm.validForm && _vm.validForm.address
                          ? ""
                          : this.checkmarkIcon
                    },
                    on: {
                      input: function(address) {
                        return _vm.updateCustomer({ address: address })
                      },
                      updateval: _vm.onUpdateAddressValue,
                      selectitem: _vm.onAddressSelection
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.errors.address
                ? _c("msg-block", { attrs: { type: "error" } }, [
                    _vm.errors.address
                      ? _c("p", [
                          _c("b", {
                            domProps: {
                              textContent: _vm._s(_vm.errors.address[0])
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-fields" },
            [
              _c(
                "div",
                { staticClass: "input-fields__content" },
                [
                  _c("input-field", {
                    staticClass: "booking-field booking-field--zipcode",
                    attrs: {
                      name: _vm.translations.input_postal,
                      "input-type": "tel",
                      mask: "9999",
                      value: _vm.value.zipCode,
                      "icon-type":
                        _vm.validForm && _vm.validForm.zipCode
                          ? ""
                          : this.checkmarkIcon
                    },
                    on: {
                      input: function(inp) {
                        return this$1.updateCustomer({
                          zipCode: inp.substr(0, 4)
                        })
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input-field", {
                    staticClass: "booking-field booking-field--city",
                    attrs: {
                      name: _vm.translations.input_town,
                      value: _vm.value.city,
                      "icon-type":
                        _vm.validForm && _vm.validForm.city
                          ? ""
                          : this.checkmarkIcon
                    },
                    on: {
                      input: function(city) {
                        return _vm.updateCustomer({ city: city })
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.errors.zipCode || _vm.errors.city
                ? _c("msg-block", { attrs: { type: "error" } }, [
                    _vm.errors.zipCode
                      ? _c("p", [
                          _c("b", {
                            domProps: {
                              textContent: _vm._s(_vm.errors.zipCode[0])
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errors.city
                      ? _c("p", [
                          _c("b", {
                            domProps: {
                              textContent: _vm._s(_vm.errors.city[0])
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-fields" }, [
            _c(
              "div",
              { staticClass: "input-fields__content" },
              [
                _c("selector", {
                  staticClass: "booking-field booking-field--country",
                  attrs: {
                    value: _vm.value.countryCode,
                    options: _vm.countries,
                    "icon-type":
                      _vm.validForm && _vm.validForm.countryCode
                        ? "drop-down"
                        : this.checkmarkIcon
                  },
                  on: {
                    input: function(countryCode) {
                      this$1.updateCustomer({ countryCode: countryCode })
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors.countryCode
                  ? _c("msg-block", { attrs: { type: "error" } }, [
                      _vm.errors.countryCode
                        ? _c("p", [
                            _c("b", {
                              domProps: {
                                textContent: _vm._s(_vm.errors.countryCode[0])
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-fields" },
            [
              _c("div", { staticClass: "input-fields__header" }, [
                _c("h3", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.contact_header)
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-fields__content" },
                [
                  _c("input-field", {
                    staticClass: "booking-field booking-field--mail",
                    attrs: {
                      name: _vm.translations.input_email,
                      "input-type": "email",
                      value: _vm.value.email,
                      "icon-type":
                        _vm.validForm && _vm.validForm.email
                          ? ""
                          : this.checkmarkIcon
                    },
                    on: {
                      input: function(email) {
                        return _vm.updateCustomer({ email: email })
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input-field", {
                    staticClass: "booking-field booking-field--mailconfirm",
                    attrs: {
                      name: _vm.translations.input_email_confirm,
                      "input-type": "email",
                      value: _vm.email_confirm,
                      "icon-type":
                        _vm.validForm && _vm.validForm.email_confirm
                          ? ""
                          : this.checkmarkIcon
                    },
                    on: {
                      input: function(inp) {
                        return (this$1.email_confirm = inp)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.errors.email || _vm.errors.email_confirm
                ? _c("msg-block", { attrs: { type: "error" } }, [
                    _vm.errors.email
                      ? _c("p", [
                          _c("b", {
                            domProps: {
                              textContent: _vm._s(_vm.errors.email[0])
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errors.email_confirm
                      ? _c("p", [
                          _c("b", {
                            domProps: {
                              textContent: _vm._s(_vm.errors.email_confirm[0])
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-fields" },
            [
              _c(
                "div",
                { staticClass: "input-fields__content" },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "booking-field booking-field--countrycode-text"
                    },
                    [_vm._v("+")]
                  ),
                  _vm._v(" "),
                  _c("phone-code-field", {
                    staticClass: "booking-field booking-field--countrycode",
                    attrs: {
                      country: _vm.value.countryCode,
                      name: _vm.translations.input_countrycode,
                      "icon-type":
                        _vm.validForm && _vm.validForm.phone_contrycode
                          ? ""
                          : this.checkmarkIcon
                    },
                    model: {
                      value: _vm.phone_contrycode,
                      callback: function($$v) {
                        _vm.phone_contrycode = $$v
                      },
                      expression: "phone_contrycode"
                    }
                  }),
                  _vm._v(" "),
                  _c("input-field", {
                    staticClass: "booking-field booking-field--phone",
                    attrs: {
                      name: _vm.translations.input_phone,
                      "input-type": "tel",
                      "icon-type":
                        _vm.validForm && _vm.validForm.phone
                          ? ""
                          : this.checkmarkIcon
                    },
                    model: {
                      value: _vm.phone_number,
                      callback: function($$v) {
                        _vm.phone_number = $$v
                      },
                      expression: "phone_number"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.errors.phone
                ? _c("msg-block", { attrs: { type: "error" } }, [
                    _vm.errors.phone
                      ? _c("p", [
                          _c("b", {
                            domProps: {
                              textContent: _vm._s(_vm.errors.phone[0])
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-fields" }, [
            _c("div", { staticClass: "input-fields__header" }, [
              _c("h3", {
                domProps: {
                  textContent: _vm._s(_vm.translations.comment_headline)
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-fields__content" },
              [
                _c("input-field", {
                  staticClass: "booking-field booking-field--comment",
                  attrs: {
                    name: _vm.translations.input_comment,
                    value: _vm.comment,
                    "input-type": "textarea"
                  },
                  on: {
                    input: function(val) {
                      return _vm.updateComment(val)
                    }
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-fields" },
            [
              _c("div", { staticClass: "input-fields__header" }, [
                _c("h3", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.voucher_headline)
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-fields__content" },
                [
                  _c("input-field", {
                    staticClass: "booking-field booking-field--voucher",
                    class: {
                      "booking-field--voucher--success":
                        _vm.validForm && _vm.validForm.voucher_code
                    },
                    attrs: {
                      "input-type": "text",
                      "icon-type":
                        _vm.validForm && _vm.validForm.voucher_code
                          ? ""
                          : this.checkmarkIcon
                    },
                    model: {
                      value: _vm.voucher_code,
                      callback: function($$v) {
                        _vm.voucher_code = $$v
                      },
                      expression: "voucher_code"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.errors.voucher_code
                ? _c("msg-block", { attrs: { type: "error" } }, [
                    _vm.errors.voucher_code
                      ? _c("p", [
                          _c("b", {
                            domProps: {
                              textContent: _vm._s(_vm.errors.voucher_code[0])
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("GmapMap", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false"
              }
            ],
            ref: "map",
            attrs: { center: { lat: 10, lng: 10 } }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "view" }, [
        _c("table", { staticClass: "table" }, [
          _c("tbody", [
            _c("tr", [
              _c("td", {
                domProps: {
                  textContent: _vm._s(_vm.translations.input_firstname)
                }
              }),
              _vm._v(" "),
              _c("td", {
                domProps: { textContent: _vm._s(_vm.value.firstName) }
              })
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", {
                domProps: {
                  textContent: _vm._s(_vm.translations.input_lastname)
                }
              }),
              _vm._v(" "),
              _c("td", {
                domProps: { textContent: _vm._s(_vm.value.lastName) }
              })
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", {
                domProps: {
                  textContent: _vm._s(_vm.translations.input_address)
                }
              }),
              _vm._v(" "),
              _c("td", { domProps: { textContent: _vm._s(_vm.value.address) } })
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", {
                domProps: { textContent: _vm._s(_vm.translations.input_postal) }
              }),
              _vm._v(" "),
              _c("td", { domProps: { textContent: _vm._s(_vm.value.zipCode) } })
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", {
                domProps: { textContent: _vm._s(_vm.translations.input_town) }
              }),
              _vm._v(" "),
              _c("td", { domProps: { textContent: _vm._s(_vm.value.city) } })
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", {
                domProps: {
                  textContent: _vm._s(_vm.translations.input_country)
                }
              }),
              _vm._v(" "),
              _c("td", {
                domProps: {
                  textContent: _vm._s(
                    _vm.selectedContry ? _vm.selectedContry.text : ""
                  )
                }
              })
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", {
                domProps: { textContent: _vm._s(_vm.translations.input_email) }
              }),
              _vm._v(" "),
              _c("td", { domProps: { textContent: _vm._s(_vm.value.email) } })
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", {
                domProps: { textContent: _vm._s(_vm.translations.input_phone) }
              }),
              _vm._v(" "),
              _c("td", { domProps: { textContent: _vm._s(_vm.value.phone) } })
            ]),
            _vm._v(" "),
            _vm.comment
              ? _c("tr", [
                  _c("td", {
                    domProps: {
                      textContent: _vm._s(_vm.translations.comment_headline)
                    }
                  }),
                  _vm._v(" "),
                  _c("td", { domProps: { textContent: _vm._s(_vm.comment) } })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.validOfferCode
              ? _c("tr", [
                  _c("td", {
                    domProps: {
                      textContent: _vm._s(_vm.translations.voucher_headline)
                    }
                  }),
                  _vm._v(" "),
                  _c("td", {
                    domProps: { textContent: _vm._s(_vm.voucher_code) }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("tr", [
              _c("td", {
                domProps: {
                  textContent: _vm._s(_vm.translations.input_newsletter)
                }
              }),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.newsletter
                      ? _vm.translations.newsletter_yes
                      : _vm.translations.newsletter_no
                  )
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.editMode
        ? _c(
            "div",
            {
              staticClass: "booking-newsletter",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("checkbox", {
                attrs: {
                  name: _vm.translations.input_newsletter,
                  value: _vm.newsletter
                },
                on: {
                  checked: function(val) {
                    return _vm.updateNesletterSetting(val)
                  }
                }
              }),
              _vm._v(" "),
              _c("p", {
                staticClass: "booking-newsletter__text",
                domProps: {
                  textContent: _vm._s(_vm.translations.newsletter_text)
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ed60c12", { render: render, staticRenderFns: staticRenderFns })
  }
}